import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import PreviewIcon from '@mui/icons-material/Preview';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import GavelIcon from '@mui/icons-material/Gavel';
import AddTaskIcon from '@mui/icons-material/AddTask';
import TaskIcon from '@mui/icons-material/Task';
import GridViewIcon from '@mui/icons-material/GridView';
import LaunchIcon from '@mui/icons-material/Launch';
import ConfirmationDialog from './ConfirmationDialog'
import JSONForm from './JSONForm'
import ViewDocx from './ViewDocx'
import RefreshIcon from '@mui/icons-material/Refresh';
import TransformerResultDetail from './TransformerResultDetail';
import Modal from '@mui/material/Modal';
import {  useParams } from 'react-router-dom';
import { useState, useEffect} from 'react';
import Grid from '@mui/material/Grid';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepContent from '@mui/material/StepContent';
import StepButton from '@mui/material/StepButton';
import Stack from '@mui/material/Stack';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
import TableBody from '@mui/material/TableBody';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import BugReportIcon from '@mui/icons-material/BugReport';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LinearProgress from '@mui/material/LinearProgress';
import Button from '@mui/material/Button';
import { DataGrid, GridColDef, GridToolbar, gridDateComparator } from '@mui/x-data-grid';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import CaseFacts from './CaseFacts'
import DocumentProgress from './DocumentProgress'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios';
import { JsonEditor } from 'json-edit-react'
import { HOST } from '../components/config';

const DocumentLogs = (props) => {
  const { caseId } = useParams();
  const caseDocumentInfo = props.assemblyCaseDocumentInfo;
  const assemblyCaseDocumentId = props.assemblyCaseDocumentInfo.id;
  const [previewUrl, setPreviewUrl] = useState(null); 
  const [showOutput, setShowOutput] = useState(props.showOutput || true)
  const [previewType, setPreviewType] = useState(null); 
  const [activeStep, setActiveStep] = useState(caseDocumentInfo.is_context_document ? 1 : 3); 

  const [showLoading, setShowLoading]= useState(false); 

  useEffect(()=> {
    setActiveStep((caseDocumentInfo.is_context_document ? 1 : 3))
  }, [caseDocumentInfo.id])

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '80%',
    border: '3px solid grey[200]',
    boxShadow: '0 4px 12px rgb(0 0 0 / 0.2)',
    bgcolor: 'background.paper',
    borderRadius: 2,
    p: 4,
  };
  
  const submodalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display:'block',
    overflow:'scroll',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const transformers = props.transformers
  const transformerResults = props.results

  const [isGenerating, setIsGenerating] = useState(false);
  const [results, setResults] = useState([]);
  const [resultRuns, setResultRuns] = useState([]);
  const [resultInfo, setResultInfo] = useState([]);
  const [templateJson, setTemplateJson] = useState({});
  const [assemblyDocumentInputsInfo, setAssemblyDocumentInputsInfo] = useState([]);
  const [inputDocumentsInfo, setInputDocumentsInfo] = useState({});
  const [pendingResultToDeleteId, setPendingResultToDeleteId] = useState(null);
  const [pendingOutputViewResultJson, setPendingOutputViewResultJson] = useState(null);

  const [assemblyTransformerModalId, setAssemblyTransformerModalId] = useState(null); 

  const fetchAssemblyDocInputs = () => {
    fetch(HOST + '/api/assembly_document_assembly_document_inputs/?assembly_document_id='+ caseDocumentInfo.assembly_document_id,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setAssemblyDocumentInputsInfo(json)
      json.map((doc) => fetchInputDocument(doc.assembly_document_source_id) ) 
   })
  }
  const handleUpdateCaseDocTemplateJson = async (newTemplateJson) => {
      try {
        fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId + '/',
        {   
          "method": "PATCH",
          "headers" : { 
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
            },  
          "body": JSON.stringify({ template_json: newTemplateJson }) 
         })
        .then((res) => res.json())
        .then((json) => {
          setTemplateJson(newTemplateJson)
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };
  const handleCaseDocDownload = async () => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
      }   
    };
  const fetchCaseDocumentTemplateJsonToEdit= async () => {
    try {
      const response = await fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
      });
      const json = await response.json()
      setTemplateJson(json.template_json)
    }
    catch (err) {
    }
  }
  const handlePreview= async () => {
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assemblyCaseDocumentId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        setPreviewUrl(download_url)
        setPreviewType(json['generate_filetype'])
      } catch (err) {
      }   
    };
  const fetchInputDocument = (assembly_doc_id) => {
    fetch(HOST + '/api/assembly_documents/'+ assembly_doc_id,
    {   
      "method": "GET",
      "headers" : { 
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
        },  
     })
    .then((res) => res.json())
    .then((json) => {
      setInputDocumentsInfo((prevState) => ({...prevState, [assembly_doc_id]: json })   )
   })
  }
  const handleRunDownload = async (run_id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_result_runs/' + run_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
      }   
    };
 
  const inputFactsPrepared = () => {
    return false 
  }

  const inputDocumentsPrepared = () => {
    return false 
  }
  
  const transformersComplete = () => {
    return false 
  }

  useEffect( () => {
    fetchAssemblyDocInputs()
    fetchCaseDocumentTemplateJsonToEdit() 
    const intervalId = setInterval(() => { 
      fetchCaseDocumentTemplateJsonToEdit()
 }, 5000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };
  }, [props.assemblyCaseDocumentInfo]);

  const onCancel = props.onCancel;
  const onUpload = props.onUpload;
  
  const paginationModel = { page: 0, pageSize: 10 };
  
  const handleCaseDocGenerate = async (assembly_case_document_id) => {
      setIsGenerating(true) 
      try {
        const response = await fetch(HOST + '/api/assembly_case_documents/' + assembly_case_document_id+'/generate/', { 
          "method": "POST",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
      } catch (err) {
      }   
  };
  const getStatusChip = (item) => { return(item.status == 'SUCCESS' ? 
        (<Chip  className="chip-boxy" label="Generated" color="success" variant="" />) : 
        item.status.includes('ERROR') ?  
        (<Chip  className="chip-boxy" label={"Generation Error"} color="error" variant="" />) :
        item.status.includes('PREPARE') ?  
        (<Chip  className="chip-boxy"  label="Pending Generation" color="warning" variant="" />) : 
        (<Chip  className="chip-boxy"  label="Generating" color="info" variant="" />)) 
  }
  
  const format_date = (d) => (new Date(d)).toLocaleString()
  const isProcessing = caseDocumentInfo.generated_status =='GENERATING' 
  const hasError = caseDocumentInfo.generated_status == 'ERROR' 
  const success = caseDocumentInfo.generated_status == 'SUCCESS' 

  useEffect( () => {
    if (caseDocumentInfo.is_context_document && transformers.length == 1) {
      const first_transformer_id = transformers[0].id
      const transformer_info = transformerResults.filter((item) => item.transformer_id == first_transformer_id)[0] 
      if (transformer_info) {
        if (transformer_info.total == 0 || transformer_info.total != transformer_info.count_success)
          setAssemblyTransformerModalId(transformers[0].id)
      }
    }
  }, [transformerResults]);

  const contextDocStepOffset = caseDocumentInfo.is_context_document ? -2 : 0 
  const docxPreviewer = <ViewDocx docUrl={previewUrl} docType={previewType}/>
  const input_document_ids = assemblyDocumentInputsInfo.map((item) => item.assembly_document_source_id) 

  const documentStep = ( () => {
    if (success)
      return 'Generate'
    else if (caseDocumentInfo.is_context_document && transformers.length > transformerResults.length) 
      return 'Run Processors'
    else if (success)
      return 'Generate'
    else if (transformerResults.filter((item) => item.total == 0 || (item.total != item.count_success)).length > 0) 
      return 'Run Processors'
    else
      return 'Review Result' 
  })()

  return (  <Box sx={{p: 2}}>
     
          <Box>
            
      <Stepper nonLinear sx={{mt: 2}} orientation="vertical" activeStep={activeStep} >
          {transformerResults.length > 0 && transformerResults.map((item, ind) => { 
            
            const stepIndex = ind  
            return (<Step key={stepIndex}  >
                <StepButton onClick={() => setActiveStep(stepIndex == activeStep ? null : stepIndex)}>
                  <Typography sx={{}} variant='h6' component='h6'>
                    Processing: <b style={{marginRight: "5px" }} x={{mr: 2}}>{item.label}</b> 
                                {item.count_processing == 1 ? 
                                (<Chip  className="chip-boxy" sx={{m: 1}} label={'Running'} color="info" variant="" />)  : 
                                item.count_processing > 1 ? 
                                (<Badge badgeContent={item.count_processing} color="info"><Chip  className="chip-boxy" label={'Running'} color="info" variant="" /></Badge>)  : 
                                item.count_errored > 0 ?  
                                (<Badge badgeContent={item.count_errored} color="error"><Chip  className="chip-boxy" label={'Errored'} color="error" variant="" /></Badge>) :
                                item.count_success > 1 ?  
                                (<Badge badgeContent={item.count_success} color="success"><Chip  className="chip-boxy" label={'Success'} color="success" variant="" /></Badge>): 
                                item.count_success == 1 ?  
                                (<Chip  className="chip-boxy" sx={{ m: 1}} label={'Success'} color="success" variant="" />) : 
                                (<Chip  className="chip-boxy" sx={{ m: 1}} label={'Needs Review'} color="warning" variant="" />)} 
                  </Typography>
                </StepButton>
              <StepContent>
               <Box sx={{ padding: 3 }}>
                <TransformerResultDetail 
                  // TODO: add to logs view with this removed
                  hideDetails={false}
                  assemblyTransformerId={item.transformer_id} 
                  assemblyCaseDocumentId={caseDocumentInfo.id} 
                  caseDocumentInfo={caseDocumentInfo}
                  onCancel={() => setAssemblyTransformerModalId(null)}
                  />
                </Box>
              </StepContent>
            </Step>)
          })}
          
          <Step key={transformerResults.length}  >
              <StepButton onClick={() => setActiveStep(activeStep == (transformerResults.length) ? null : (transformerResults.length))}>
              <Typography sx={{}} variant='h6' component='h6'>
                Generation: <b>History</b> 
              </Typography>
             </StepButton>
            <StepContent>
              Coming soon... (Generation history)
            </StepContent>
          </Step>
          </Stepper>
          </Box>
  </Box>
)
}

export default DocumentLogs;
